import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ClipboardList, Minus, Plus, ShoppingCart } from 'lucide-react';

// Publicación del módulo de papelería. Conserva el formato de los anuncios de
// Inicio y muestra una lista ilustrativa inspirada en el catálogo y su carrito.
// Las cantidades son solo del ejemplo: la solicitud real se inicia desde el enlace.
const ARTICULOS = [
  { id: 'boligrafo', nombre: 'Bolígrafo', cantidad: 2 },
  { id: 'papel', nombre: 'Resma de papel', cantidad: 1 },
  { id: 'clips', nombre: 'Clips', cantidad: 1 },
];

const styles = `
  .spb-card {
    position: relative;
    container-type: inline-size;
    overflow: hidden;
    border: 1px solid #304569;
    border-radius: 16px;
    color: #fff;
    background: linear-gradient(125deg, #22345b 0%, #1f2d52 52%, #111e38 100%);
    box-shadow: 0 20px 52px -38px rgba(19,29,58,.9);
  }
  .spb-layout { display: flex; align-items: center; }
  .spb-copy { position: relative; z-index: 1; flex: 1; min-width: 0; padding: 24px 0 24px 28px; }
  .spb-eyebrow { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; color: #aac8e7; font-size: 10px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; }
  .spb-title { margin: 0; color: #fff; font-size: clamp(1.15rem, 1.9vw, 1.4rem); font-weight: 700; line-height: 1.2; letter-spacing: -.015em; }
  .spb-description { margin: 9px 0 0; color: #c9d3e6; font-size: 14px; line-height: 1.5; }
  .spb-cta { display: inline-flex; align-items: center; justify-content: center; gap: 9px; margin-top: 17px; padding: 9px 15px; border-radius: 8px; background: #b9ddf5; color: #142746; font-size: 13px; font-weight: 700; text-decoration: none; transition: background-color .2s, transform .2s; }
  .spb-cta:hover { background: #d5edff; transform: translateY(-1px); }
  .spb-cta:focus-visible { outline: 2px solid #fff; outline-offset: 4px; }
  .spb-scene { position: relative; flex: 0 0 44%; min-width: 0; padding: 30px 22px 23px 26px; }
  .spb-desk { position: relative; width: 100%; max-width: 292px; margin: auto; padding: 15px 14px 0 0; }
  .spb-paper {
    position: relative;
    padding: 16px 13px 12px;
    border: 1px solid #d9e4ef;
    border-radius: 11px;
    background: #f8fbff;
    color: #22345b;
    box-shadow: 5px 5px 0 -1px #b7c9dc, 10px 10px 0 -2px #526988, 0 16px 26px -12px #070f20;
    animation: spb-hoja .85s cubic-bezier(.16,1,.3,1) .45s both;
  }
  .spb-order-heading { display: flex; align-items: center; gap: 7px; margin: 0; font-size: 13px; font-weight: 800; }
  .spb-example { margin: 3px 0 12px 23px; color: #61738b; font-size: 10px; }
  .spb-items { margin: 0; padding: 0; list-style: none; }
  .spb-item { display: flex; align-items: center; gap: 7px; min-height: 48px; border-top: 1px solid #e0e8f1; animation: spb-fila .6s ease both; }
  .spb-item:nth-child(1) { animation-delay: .85s; }
  .spb-item:nth-child(2) { animation-delay: 1.05s; }
  .spb-item:nth-child(3) { animation-delay: 1.25s; }
  .spb-item-art { width: 26px; height: 30px; flex: none; animation: spb-toque .35s ease; }
  .spb-item-art svg { display: block; width: 100%; height: 100%; }
  .spb-item-name { flex: 1; min-width: 0; font-size: 11px; font-weight: 600; line-height: 1.3; }
  .spb-quantity { display: flex; align-items: center; gap: 2px; flex: none; }
  .spb-adjust { display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 28px; border: 1px solid #d4e0ec; border-radius: 6px; background: #edf3fa; color: #26456a; cursor: pointer; transition: background-color .15s; }
  .spb-adjust:hover:not(:disabled) { background: #d4e6f5; }
  .spb-adjust:focus-visible { outline: 2px solid #0062a5; outline-offset: 2px; }
  .spb-adjust:disabled { opacity: .35; cursor: default; }
  .spb-number { display: inline-block; min-width: 16px; text-align: center; font-size: 12px; font-weight: 800; font-variant-numeric: tabular-nums; animation: spb-toque .35s ease; }
  .spb-order-total { display: flex; align-items: center; justify-content: space-between; gap: 6px; padding-top: 10px; border-top: 1px dashed #bccddd; color: #536b85; font-size: 10px; }
  .spb-order-total strong { color: #22345b; font-size: 11px; }
  .spb-pencil { position: absolute; right: -9px; top: 46px; width: 23px; height: 150px; pointer-events: none; transform: rotate(12deg); transform-origin: 50% 90%; animation: spb-lapiz 1.8s ease-in-out .8s both; }
  .spb-clip { position: absolute; right: 38px; top: 2px; width: 21px; height: 38px; pointer-events: none; animation: spb-fila .7s ease .7s both; }
  .spb-footer { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 8px 16px; padding: 11px 28px; border-top: 1px solid rgba(185,221,245,.12); background: rgba(8,19,39,.25); color: #c1cfe2; font-size: 11px; line-height: 1.5; }
  .spb-step { display: inline-flex; align-items: center; gap: 7px; }
  .spb-step b { color: #8eacca; font-size: 10px; font-variant-numeric: tabular-nums; }

  @keyframes spb-hoja { from { opacity: 0; transform: translateY(18px) rotate(-6deg); } to { opacity: 1; transform: none; } }
  @keyframes spb-fila { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
  @keyframes spb-toque { 0%, 100% { transform: scale(1); } 45% { transform: scale(1.18); } }
  @keyframes spb-lapiz {
    0% { opacity: 0; transform: translate(20px, -20px) rotate(25deg); }
    25% { opacity: 1; transform: translate(-12px, 0) rotate(4deg); }
    45% { transform: translate(-6px, 5px) rotate(10deg); }
    65% { transform: translate(-12px, 10px) rotate(4deg); }
    100% { opacity: 1; transform: rotate(12deg); }
  }
  @media (max-width: 639px) {
    .spb-layout { flex-direction: column; align-items: stretch; }
    .spb-copy { padding: 22px 24px 0; }
    .spb-scene { flex-basis: auto; padding: 15px 30px 22px; }
    .spb-footer { padding: 11px 24px; }
  }
  @container (max-width: 620px) {
    .spb-layout { flex-direction: column; align-items: stretch; }
    .spb-copy { padding: 22px 24px 0; }
    .spb-scene { flex-basis: auto; padding: 15px 30px 22px; }
    .spb-footer { padding: 11px 24px; }
  }
  @media (prefers-reduced-motion: reduce) {
    .spb-card * { animation: none !important; transition: none !important; }
    .spb-cta:hover { transform: none; }
  }
`;

function UtilPapeleria({ tipo }) {
  return (
    <svg viewBox="0 0 32 36" fill="none" aria-hidden="true" focusable="false">
      {tipo === 'boligrafo' ? (
        <g transform="rotate(25 16 18)">
          <rect x="12" y="3" width="8" height="25" rx="3" fill="#5d93bf" />
          <rect x="12" y="3" width="8" height="8" rx="2" fill="#214469" />
          <path d="M14 28 H18 L16 33 Z" fill="#214469" />
          <path d="M18 5 V13" stroke="#b9ddf5" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M14 13 V25" stroke="#a4c8e2" strokeWidth="1.5" />
        </g>
      ) : tipo === 'papel' ? (
        <>
          <rect x="7" y="8" width="21" height="25" rx="2" fill="#b8cadb" />
          <rect x="5" y="5" width="21" height="25" rx="2" fill="#e2eaf2" stroke="#95aec5" />
          <rect x="3" y="2" width="21" height="25" rx="2" fill="#fff" stroke="#95aec5" />
          <path d="M7 9 H20 M7 13 H20 M7 17 H17" stroke="#b8cadb" strokeWidth="1.5" />
          <path d="M3 21 H24" stroke="#5d93bf" strokeWidth="4" />
        </>
      ) : (
        <g transform="rotate(22 16 18)">
          <path d="M12 25 V10 A6 6 0 0 1 24 10 V26 A9 9 0 0 1 6 26 V11" stroke="#64829e" strokeWidth="2.6" strokeLinecap="round" />
          <path d="M12 25 A3 3 0 0 0 18 25 V11" stroke="#64829e" strokeWidth="2.6" strokeLinecap="round" />
        </g>
      )}
    </svg>
  );
}

function ListaIlustrativa() {
  const [cantidades, setCantidades] = useState(() => Object.fromEntries(
    ARTICULOS.map(({ id, cantidad }) => [id, cantidad])
  ));
  const total = Object.values(cantidades).reduce((suma, cantidad) => suma + cantidad, 0);
  const ajustar = (id, cambio) => setCantidades((actual) => ({
    ...actual,
    [id]: Math.max(0, Math.min(9, actual[id] + cambio)),
  }));

  return (
    <div className="spb-scene">
      <div className="spb-desk">
        <div className="spb-paper" role="group" aria-label="Ejemplo interactivo de una lista de papelería">
          <h4 className="spb-order-heading"><ShoppingCart size={16} aria-hidden="true" /> Tu solicitud</h4>
          <p className="spb-example">Vista de ejemplo</p>
          <ul className="spb-items">
            {ARTICULOS.map(({ id, nombre }) => (
              <li className="spb-item" key={id}>
                <div className="spb-item-art" key={`${id}-${cantidades[id]}`}><UtilPapeleria tipo={id} /></div>
                <span className="spb-item-name">{nombre}</span>
                <div className="spb-quantity">
                  <button type="button" className="spb-adjust" onClick={() => ajustar(id, -1)} disabled={cantidades[id] === 0} aria-label={`Quitar ${nombre.toLowerCase()} del ejemplo`}>
                    <Minus size={12} aria-hidden="true" />
                  </button>
                  <span className="spb-number" key={cantidades[id]} aria-label={`${cantidades[id]}: ${nombre}`}>{cantidades[id]}</span>
                  <button type="button" className="spb-adjust" onClick={() => ajustar(id, 1)} disabled={cantidades[id] === 9} aria-label={`Agregar ${nombre.toLowerCase()} al ejemplo`}>
                    <Plus size={12} aria-hidden="true" />
                  </button>
                </div>
              </li>
            ))}
          </ul>
          <div className="spb-order-total">
            <span>Materiales seleccionados</span>
            <strong aria-live="polite" aria-atomic="true">{total} {total === 1 ? 'ítem' : 'ítems'}</strong>
          </div>
        </div>
        <svg className="spb-clip" viewBox="0 0 21 38" fill="none" aria-hidden="true" focusable="false">
          <path d="M7 28 V9 A5 5 0 0 1 17 9 V28 A8 8 0 0 1 1 28 V12" stroke="#9db2c8" strokeWidth="2.5" strokeLinecap="round" />
          <path d="M7 28 A2 2 0 0 0 11 28 V10" stroke="#9db2c8" strokeWidth="2.5" strokeLinecap="round" />
        </svg>
        <svg className="spb-pencil" viewBox="0 0 23 150" fill="none" aria-hidden="true" focusable="false">
          <path d="M4 19 H19 V126 L11.5 145 L4 126 Z" fill="#e9b754" />
          <path d="M4 19 H9 V126 H4 Z" fill="#ffe0a2" />
          <path d="M15 19 H19 V126 H15 Z" fill="#bc8436" />
          <path d="M4 126 H19 L11.5 145 Z" fill="#f2dcc0" />
          <path d="M8.5 138 H14.5 L11.5 146 Z" fill="#233653" />
          <rect x="4" y="3" width="15" height="16" rx="4" fill="#d88783" />
          <path d="M4 17 H19 V25 H4 Z" fill="#b7c9dc" />
          <path d="M5 20 H18 M5 23 H18" stroke="#e3edf6" />
        </svg>
      </div>
    </div>
  );
}

export default function SolicitudPapeleriaBanner() {
  return (
    <>
      <style>{styles}</style>
      <section className="spb-card" aria-label="Solicitud de Papelería en Centro Sura">
        <div className="spb-layout">
          <div className="spb-copy">
            <div className="spb-eyebrow"><ClipboardList size={22} aria-hidden="true" /> Nuevo en Centro Sura</div>
            <h3 className="spb-title">Tu papelería ahora se solicita<br />en Centro Sura</h3>
            <p className="spb-description">
              Elige los artículos del catálogo, ajusta las cantidades y envía tu
              solicitud. Sigue su estado y confirma cuando recibas el material.
            </p>
            <Link to="/solicitud-papeleria?tab=create" className="spb-cta">
              Solicitar papelería <ArrowRight size={15} strokeWidth={2.5} aria-hidden="true" />
            </Link>
          </div>
          <ListaIlustrativa />
        </div>
        <div className="spb-footer">
          <span className="spb-step"><b>01</b> Elige tus artículos</span>
          <span className="spb-step"><b>02</b> Envía tu solicitud</span>
          <span className="spb-step"><b>03</b> Confirma la recepción</span>
        </div>
      </section>
    </>
  );
}
